import RebatePolicy from './rebate_policy.vue';

export default RebatePolicy;
